import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AnalyticsSection from 'components/dashboard/analytics-content/AnalyticsSection';
import AnalyticsMainMetrics from 'components/dashboard/analytics-content/AnalyticsMainMetrics';
import AnalyticsActivityCharts from 'components/dashboard/analytics-content/AnalyticsActivityCharts';
import AnalyticsDayPicker from 'components/dashboard/analytics-content/AnalyticsDayPicker';
import AnalyticsTopLinks from 'components/dashboard/analytics-content/AnalyticsTopLinks';
import AnalyticsDeviceCategory from 'components/dashboard/analytics-content/AnalyticsDeviceCategory';
import AnalyticsMobileDevices from 'components/dashboard/analytics-content/AnalyticsMobileDevices';
import AnalyticsAudienceByCountry from 'components/dashboard/analytics-content/AnalyticsAudienceByCountry';
import AnalyticsAudienceByContinents from 'components/dashboard/analytics-content/AnalyticsAudienceByContinents';
import AnalyticsCountriesList from 'components/dashboard/analytics-content/AnalyticsCountriesList';
import AnalyticsAudienceByCity from 'components/dashboard/analytics-content/AnalyticsAudienceByCity';
import AnalyticsByReferrers from 'components/dashboard/analytics-content/AnalyticsByReferrers';

import './AnalyticsPageContent.css';
import CommonMessage from "components/common/CommonMessage";

const AnalyticsPageContent = () => {
  const { t } = useTranslation();
  const dropdownOptions = [
    {
      key: 'last_week',
      text: t("Last Week"),
      value: 7,
      content: t("Last Week"),
    },
    {
      key: 'last_2_weeks',
      text: t("Last 2 Weeks"),
      value: 14,
      content: t("Last 2 Weeks"),
    },
    {
      key: 'last_month',
      text: t("Last Month"),
      value: 30,
      content: t("Last Month"),
    },
    {
      key: 'last_3_month',
      text: t("Last 3 Months"),
      value: 90,
      content: t("Last 3 Months"),
    },
    {
      key: 'last__6_month',
      text: t("Last 6 Months"),
      value: 180,
      content: t("Last 6 Months"),
    },
  ];
  const [dateSelected, setDateSelected] = useState(dropdownOptions[dropdownOptions.length - 1].value);
  const [dateSelectedLabel, setDateSelectedLabel] = useState(dropdownOptions[dropdownOptions.length - 1].content);

  const handleDateSelect = (date) => {
    const { value, options } = date;
    const detectOption = options && options.filter(i => i.value === value)[0];

    setDateSelected(value);
    setDateSelectedLabel(detectOption.content);
  };

  return (
    <div className="analytics-page-content__component">
      {/* Page Header */}
      <div className="page-header">
        <div className="title">{t("ANALYTICS")}</div>
        <a
          className="info-icon"
          href="https://blog.heylink.me/2020/11/24/how-to-use-google-analytics-utm-parameters-in-2020/"
          target="_blank"
          rel="noopener noreferrer"
        />
      </div>

      <div className="info-message">
        <CommonMessage info>
          {t("Please note that analytics data is refreshed once a day." +
             "This can delay updates to dimensions and metrics for up to two days.")}
        </CommonMessage>
      </div>

      {/* Date selector */}
      <AnalyticsSection className="basic">
        <AnalyticsDayPicker
          options={dropdownOptions}
          handleDateSelect={handleDateSelect}
        />
      </AnalyticsSection>

      {/* Main metrics (views, unique visitors, clicks, CTR) */}
      <AnalyticsMainMetrics
        date={dateSelected}
        label={dateSelectedLabel}
      />

      {/* Link Performance by Date */}
      <AnalyticsActivityCharts date={dateSelected} />

      {/* My Top Links */}
      <AnalyticsTopLinks date={dateSelected} />

      {/* Views by Device Category | Mobile Devices */}
      <AnalyticsSection row>
        <AnalyticsDeviceCategory date={dateSelected} />
        <AnalyticsMobileDevices date={dateSelected} />
      </AnalyticsSection>

      {/* Views by Country (map) | Views by Global Market */}
      <AnalyticsSection row>
        <AnalyticsAudienceByCountry date={dateSelected} />
        <AnalyticsAudienceByContinents date={dateSelected} />
      </AnalyticsSection>

      {/* Views by Country | Views by City */}
      <AnalyticsSection row>
        <AnalyticsCountriesList date={dateSelected} />
        <AnalyticsAudienceByCity date={dateSelected} />
      </AnalyticsSection>

      {/* Views by Referrer */}
      <AnalyticsByReferrers date={dateSelected} />
    </div>
  );
};

export default AnalyticsPageContent;
